import axios from 'axios';

const APP_KEY = '5D349675-5998-4E52-8A56-CA2592271736';

const authUser = axios.create({
  baseURL: 'https://cls.opt4solution.site/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    AppKey: APP_KEY,
  },
});

export const verifyUser = (payload) =>
  authUser.post('/Auth/VerifyUser', payload, {
    headers: {
      AppKey: APP_KEY,
    },
  });

export const verifyMfaOtp = (payload) =>
  authUser.post('/Auth/VerifyMfaOtp', payload, {
    headers: {
      AppKey: APP_KEY,
    },
  });

export default authUser;
